// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"8b2457e1","463":"acc10c8b"}[chunkId] + ".chunk.css";
};